import { Page } from '../../../../../components/page/page';
import { ShiftsControls } from './shifts-controls/shifts-controls';
import { ShiftsDates } from './shifts-dates/shifts-dates';
import { ShiftsGrid } from './shifts-grid/shifts-grid';
import s from './shifts.module.css';

export const Shifts = () => {
  return (
    <Page className={s.page}>
      <ShiftsControls />
      <ShiftsDates />
      <ShiftsGrid />
    </Page>
  );
};
